import { StyleSheet, View } from 'react-native'
import { useMemo } from 'react'

const Stack = ({ children, direction = 'row', ...props }) => {
	
	const style = useMemo( () => {
		return StyleSheet.flatten( props.style ?? {} )
	}, [ props.style ] )
	
	return (
		<View
			style={[
				{
					...props,
					...style,
					gap: props.space ?? 4,
					flexDirection: direction,
					flexReverse: true,
					flex: typeof props.flex !== 'undefined' ? props.flex : ( style.flex ?? undefined ),
				},
			]}>
			
			{ children}
		</View>
	)
}

export default Stack;
